import { MDS_COLORS_BACKGROUND_INVERSE, MDS_COLORS_INK_STRONG, MDS_COLORS_INK_WEAK, MDS_COLORS_LINE_BORDER, } from '@rappi/mustache-b2b-foundations';
import styled from 'styled-components';
export const Container = styled.div `
  width: 100%;
  display: grid;
  grid-auto-columns: 1fr;
  grid-auto-flow: column;
  border-radius: 8px;
  border: 1px solid ${MDS_COLORS_LINE_BORDER};
  overflow: hidden;
`;
export const Stat = styled.div `
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 4px;
  width: 100%;
  padding: 16px;
  background-color: ${MDS_COLORS_BACKGROUND_INVERSE};

  ${({ $index, $total }) => $index < $total - 1 &&
    `
    border-right: 1px solid ${MDS_COLORS_LINE_BORDER}
  `}
`;
export const Title = styled.h3 `
  font-size: 10px;
  font-weight: 600;
  line-height: 18px;
  letter-spacing: 0.012em;
  color: ${MDS_COLORS_INK_WEAK};
`;
export const Value = styled.span `
  font-size: 18px;
  font-weight: 600;
  line-height: 26px;
  color: ${MDS_COLORS_INK_STRONG};
`;
